module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./ClientApp/locales/en.json
// module id = JxAT
// module chunks = 1